import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ef14c92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-5 mb-5" }, "Uploaded Audio Files", -1))
const _hoisted_3 = { class: "content flex flex-wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "mb-1 flex flex-row items-center"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_9 = { class: "px-1 py-1" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "z-32" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DotsVerticalIcon = _resolveComponent("DotsVerticalIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_AudioDeletionModal = _resolveComponent("AudioDeletionModal")!

  return (_ctx.computedAudios.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedAudios, (audio) => {
            return (_openBlock(), _createElementBlock("div", {
              key: audio.id,
              onClick: _withModifiers(($event: any) => (
                        _ctx.routeTo(
                            `/audio/${audio.id}/${audio.fileName.replace(/[^a-zA-Z0-9-_]/g, '+')}`
                        )
                    ), ["self"]),
              class: "audio-card cursor-pointer flex shadow-md w-52 items-center mx-5 my-5"
            }, [
              _createElementVNode("div", {
                onClick: _withModifiers(($event: any) => (
                            _ctx.routeTo(
                                `/audio/${audio.id}/${audio.fileName.replace(
                                    /[^a-zA-Z0-9-_]/g,
                                    '+'
                                )}`
                            )
                        ), ["self"]),
                class: "audio-logo h-10 w-10 mx-3"
              }, null, 8, _hoisted_5),
              _createElementVNode("div", null, [
                audio
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("h3", {
                        onClick: _withModifiers(($event: any) => (
                                    _ctx.routeTo(
                                        `/audio/${audio.id}/${audio.fileName.replace(
                                            /[^a-zA-Z0-9-_]/g,
                                            '+'
                                        )}`
                                    )
                                ), ["self"]),
                        class: "text-left font-semibold"
                      }, _toDisplayString(audio.fileName), 9, _hoisted_7),
                      _hoisted_8,
                      _createVNode(_component_Menu, {
                        as: "div",
                        class: "relative inline-block text-left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_MenuButton, { class: "inline-flex justify-center w-full p-2 text-sm font-medium text-black bg-teal rounded-md bg-opacity-0 hover:bg-opacity-30" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DotsVerticalIcon, {
                                  class: "w-5 h-5 text-black",
                                  "aria-hidden": "true"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-100 ease-out",
                            "enter-from-class": "transform scale-95 opacity-0",
                            "enter-to-class": "transform scale-100 opacity-100",
                            "leave-active-class": "transition duration-75 ease-in",
                            "leave-from-class": "transform scale-100 opacity-100",
                            "leave-to-class": "transform scale-95 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MenuItems, { class: "absolute right-0 w-56 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg focus:outline-none z-20" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_MenuItem, null, {
                                      default: _withCtx(({ active }) => [
                                        _createElementVNode("button", {
                                          class: _normalizeClass([
                                                        active
                                                            ? 'bg-red-600 text-white'
                                                            : 'text-red-600',
                                                        'group flex rounded-md items-center w-full px-2 py-2 text-sm',
                                                    ]),
                                          onClick: () => _ctx.deleteAudio(audio)
                                        }, [
                                          _createVNode(_component_TrashIcon, {
                                            active: active,
                                            class: "w-5 h-5 mr-2 text-red-600",
                                            "aria-hidden": "true"
                                          }, null, 8, ["active"]),
                                          _createTextVNode(" Delete Audio ")
                                        ], 10, _hoisted_10)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  onClick: _withModifiers(($event: any) => (
                                _ctx.routeTo(
                                    `/audio/${audio.id}/${audio.fileName.replace(
                                        /[^a-zA-Z0-9-_]/g,
                                        '+'
                                    )}`
                                )
                            ), ["self"]),
                  class: "flex status h-11 my-2 capitalize"
                }, _toDisplayString(audio.status), 9, _hoisted_11),
                _createElementVNode("div", {
                  onClick: _withModifiers(($event: any) => (
                                _ctx.routeTo(
                                    `/audio/${audio.id}/${audio.fileName.replace(
                                        /[^a-zA-Z0-9-_]/g,
                                        '+'
                                    )}`
                                )
                            ), ["self"]),
                  class: "text-xs my-2"
                }, _toDisplayString(_ctx.timeAgo(audio.updatedAt || audio.createdAt)), 9, _hoisted_12)
              ])
            ], 8, _hoisted_4))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.audioToDelete)
            ? (_openBlock(), _createBlock(_component_AudioDeletionModal, {
                key: 0,
                audio: _ctx.audioToDelete,
                onDeleted: _ctx.fileDeleted
              }, null, 8, ["audio", "onDeleted"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}